import React from 'react';
import { ChatMessageContent } from 'src/components/conversation-window/chat-message-content';
import { ChatMessageGroup } from 'src/components/conversation-window/chat-message-group';
import { ChatMessage } from 'src/components/conversation-window/chat-message';
import { PhoneTwoTone } from '@ant-design/icons';
import * as dayjs from 'dayjs';
import * as relativeTime from 'dayjs/plugin/relativeTime';
import { phoneMask } from 'src/common/utils';
import { Row, Col, Button, Typography } from 'antd';

dayjs.extend(relativeTime)
export const ChatWindow = (props)=> {
  const listRef  = React.createRef();
  const { messages, contact, users } = props;
  React.useEffect(()=>{
    let lref = listRef.current
    const resizeObserver = new ResizeObserver(entries => {
      let contentHeight = listRef.current?.clientHeight;
      setTimeout(()=>{
        listRef.current?.scrollTo(0, contentHeight * 100)
      },100)
      
    });
    if(lref){
      resizeObserver.observe(lref);
    }
    return () => {
        if(resizeObserver && lref)
          resizeObserver.unobserve(lref);
    }
  }, [listRef]);

  const renderMessageContent = (message, style)=> (
    <ChatMessageContent message={message} contact={contact} user={message.user}/>
  );
  const renderMissedCall = (message, style) => (
    <Col className={"imessage"}>
      <span className={'missed-call-history'}>
        <Button size={"small"} icon={<PhoneTwoTone size={"large"} twoToneColor='red'/>} type="link" target={"_blank"} href={`tel:${message.content}`}>{phoneMask(message.content)}</Button> - chamada perdida {dayjs(message.received_at).fromNow()}
      </span>
    </Col>
  );
  let system_structured_messages = ["status_changed" ,"automatic_changed" ,"restored" ,"closed" ,"transfered", "marked_as_answered"]
	const renderMessage = (message) => {
		if(system_structured_messages.includes(message.content_type)){
			let info = JSON.parse(message.content);
			return (
				<Col style={{ border: 'dashed 1px #bdbdbd', backgroundColor: 'rgb(221 221 221 / 35%)', width: "100%", marginBottom: 12}} >
				<Row justify='center' >
					{message.content_type === "closed" &&
						<>
						<Col span={24}>
							<Row justify="center">
							<Typography.Text>
							<Typography.Text strong>Histórico encerrado</Typography.Text> em <Typography.Text strong>{dayjs(message.received_at).format("DD/MM/YY")} ás {dayjs(message.received_at).format("HH:mm")}</Typography.Text>
							</Typography.Text>
							</Row>
							
						</Col>
						<Col span={24}>
							<Row justify="center">
							<Typography.Text ><Typography.Text strong>Operador:</Typography.Text> { info.origin }</Typography.Text>
							</Row>
							
						</Col>
						{info.department && <Col span={24}>
							<Row justify="center">
							<Typography.Text ><Typography.Text strong>Departamento:</Typography.Text> {info.department?.name}</Typography.Text>
							</Row>
						</Col>}
						{info.status && 
						<Col span={24}>
							<Row justify="center">
							<Typography.Text ><Typography.Text strong>Status de Encerramento:</Typography.Text> {info.status?.name}</Typography.Text>
							</Row>
							
						</Col>
						}
						{info.operator_notes && 
						<Col span={24}>
							<Row justify="center">
							<Typography.Text ><Typography.Text strong>Observações:</Typography.Text> {info.operator_notes}</Typography.Text>
							</Row>
							
						</Col>
						}
					</>
					}
					{message.content_type === "status_changed" &&
					<>
						{info.status && <Typography.Text style={{marginRight: 10, marginLeft: 10, textAlign: "center"}}>
						<Typography.Text strong>{ info.origin }</Typography.Text> alterou o status para <Typography.Text strong>{info.status?.name}</Typography.Text> em <Typography.Text strong>{dayjs(message.received_at).format("DD/MM/YY")} ás {dayjs(message.received_at).format("HH:mm")}</Typography.Text>
						</Typography.Text>}
						{!info.status && <Typography.Text style={{marginRight: 10, marginLeft: 10, textAlign: "center"}}>
						<Typography.Text strong>{ info.origin }</Typography.Text> removeu o status de classificação em <Typography.Text strong>{dayjs(message.received_at).format("DD/MM/YY")} ás {dayjs(message.received_at).format("HH:mm")}</Typography.Text>
						</Typography.Text>}
						<Typography.Text></Typography.Text>
					</>
					}
					{message.content_type === "automatic_changed" &&
					<>
						<Typography.Text style={{marginRight: 10, marginLeft: 10, textAlign: "center"}}>
						<Typography.Text strong>{ info.origin }</Typography.Text>{info.automatic ? " enviou o atendimento ao modo automático": " iniciou o atendimento humano"} em <Typography.Text strong>{dayjs(message.received_at).format("DD/MM/YY")} ás {dayjs(message.received_at).format("HH:mm")}</Typography.Text>
						</Typography.Text>
					</>
					}
					{message.content_type === "restored" &&
					<>
						<Typography.Text style={{marginRight: 10, marginLeft: 10, textAlign: "center"}}>
						<Typography.Text strong>{ message.user?.name }</Typography.Text> restaurou o atendimento a partir do histórico em <Typography.Text strong>{dayjs(message.received_at).format("DD/MM/YY")} ás {dayjs(message.received_at).format("HH:mm")}</Typography.Text>
						</Typography.Text>
					</>
					}
					{message.content_type === "marked_as_answered" &&
					<>
						<Typography.Text style={{marginRight: 10, marginLeft: 10, textAlign: "center"}}>
						<Typography.Text strong>{ message.user?.name }</Typography.Text> marcou o atendimento como respondido em <Typography.Text strong>{dayjs(message.received_at).format("DD/MM/YY")} ás {dayjs(message.received_at).format("HH:mm")}</Typography.Text>
						</Typography.Text>
					</>
					}
					{message.content_type === "transfered" &&
					<>
						{info.transfer_type === 'attendant_department' && <Typography.Text style={{marginRight: 10, marginLeft: 10, textAlign: "center"}}>
						<Typography.Text strong>{ info.origin }</Typography.Text> transferiu o atendimento para <Typography.Text strong>{info.attendant?.name}</Typography.Text> no departamento <Typography.Text strong>{info.department?.name}</Typography.Text> em <Typography.Text strong>{dayjs(message.received_at).format("DD/MM/YY")} ás {dayjs(message.received_at).format("HH:mm")}</Typography.Text>
						</Typography.Text>}
						{info.transfer_type === 'attendant' && <Typography.Text style={{marginRight: 10, marginLeft: 10, textAlign: "center"}}>
						<Typography.Text strong>{ info.origin }</Typography.Text> atribuiu o atendimento para <Typography.Text strong>{info.attendant?.name}</Typography.Text> em <Typography.Text strong>{dayjs(message.received_at).format("DD/MM/YY")} ás {dayjs(message.received_at).format("HH:mm")}</Typography.Text>
						</Typography.Text>}
						{info.transfer_type === 'department' && <Typography.Text style={{marginRight: 10, marginLeft: 10, textAlign: "center"}}>
						<Typography.Text strong>{ info.origin }</Typography.Text> transferiu o atendimento para <Typography.Text strong>{info.department?.name}</Typography.Text> em <Typography.Text strong>{dayjs(message.received_at).format("DD/MM/YY")} ás {dayjs(message.received_at).format("HH:mm")}</Typography.Text>
						</Typography.Text>}
						{info.transfer_type === 'attendant_removed' && <Typography.Text style={{marginRight: 10, marginLeft: 10, textAlign: "center"}}>
						<Typography.Text strong>{ info.origin }</Typography.Text> removeu o responsável em <Typography.Text strong>{dayjs(message.received_at).format("DD/MM/YY")} ás {dayjs(message.received_at).format("HH:mm")}</Typography.Text>
						</Typography.Text>}
						{info.transfer_type === 'attendant_removed_department_changed' && <Typography.Text style={{marginRight: 10, marginLeft: 10, textAlign: "center"}}>
						<Typography.Text strong>{ info.origin }</Typography.Text> transferiu o atendimento para <Typography.Text strong>{info.department?.name}</Typography.Text> e removeu o responsável em <Typography.Text strong>{dayjs(message.received_at).format("DD/MM/YY")} ás {dayjs(message.received_at).format("HH:mm")}</Typography.Text>
						</Typography.Text>}
					</>
					}
				</Row>
				</Col>
			);
		}else if(message.content_type === 'missed_call'){
			return (
				<ChatMessage message={message} contact={message.contact} user={message.user}>
				{renderMissedCall}
				</ChatMessage>
			);
		}else{
			return (
				<ChatMessage message={message}  contact={message.contact} user={message.user}>
				{renderMessageContent}
				</ChatMessage>
			);
		}
	}

  const renderMessageGroup = (message)=> (
    <ChatMessageGroup key={message.id} message={message} user={users[message.user_id]} renderItem={renderMessage}/>
  );
  const onScrollCapture = (event) =>{
    if(event.currentTarget.scrollTop <= 30 && props.onLoadMoreRequested){
      props.onLoadMoreRequested(event)
    }
  }
  return(
    <Row style={props.style} className={"chat-background"}>
      <ul ref={listRef}  className="message-list" onScrollCapture={onScrollCapture}>
        {messages && messages.map(renderMessageGroup)}
      </ul>
    </Row>
  )
};